import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Login from './login';
import ResetPassword from './resetpassword';
import ForgetPassword from './forgetpassword';
import PQIGraph from './reports/pqi-graph';
import MainGmap from './maps/map-googlemap';
//import MainLeaflet from './maps/map-leaflet';
import MainWrld from './maps/map-wrld';
import Config from './config.json';
import AgencyInfo from './AgencyInfo';
import { config } from 'react-transition-group';
import AddUser from './adduser';

//Create on top level and pass. Login calls agencyInfo.init() in it's async constructor
let agencies = new AgencyInfo()
agencies.init()

const animatedRoute = () => (
    <Router basename={Config.homepage}>
        <Route render={({ location }) => (
            <div>
                <Route exact path="/" component={() => (<Login ag={agencies} location={location} />)} />

                <Route path="/maing" component={() => (<MainGmap ag={agencies} />)} />

                {/* <Route path="/mainl" component={() => (<MainLeaflet ag={agencies} />)} /> */}

                <Route path="/publicmap" component={() => (<MainGmap isPublic={true} ag={agencies} />)} />

                <Route path="/maing-dynamic" component={() => (<MainGmap VRIC={true} ag={agencies} />)} />

                <Route path="/mainw" component={() => (<MainWrld ag={agencies} />)} />

                <Route path="/resetpassword" component={() => (<ResetPassword ag={agencies} location={location} />)} />

                <Route path="/forgetpassword" component={() => (<ForgetPassword ag={agencies} location={location} />)} />

                <Route path="/pqi-graph" component={() => (<PQIGraph ag={agencies} />)} />

                <Route path="/adduser" component={() => (<AddUser ag={agencies} location={location} />)} />

                {/* <Route path="/surfAge-graph" component={SurfAgeGraph} />*/}
            </div>
        )} />
    </Router>
);

console.log("am I on a phone? " + window.mobileAndTabletcheck());

ReactDOM.render(
    React.createElement(animatedRoute)
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js